<button
  class="close-button z-notifier"
  color="primary"
  mat-dialog-close
  mat-button
  aria-label="dialog close icon">
  <mat-icon>close</mat-icon>
</button>

<div class="md:flex md:items-stretch">
  <div class="flex-grow">
    <h1
      class="text-xl sm:text-3xl font-bold md:mb-8 mb-4 text-center sm:text-start text-navy">
      {{ 'kimbo-wallet.wallet-transaction' | translate }}
    </h1>
    <div class="flex items-center justify-between mb-4">
      <div
        class="flex flex-col gap-y-1 sm:flex-row sm:justify-start {{
          isLoading && 'opacity-80 pointer-events-none'
        }}">
        <app-global-dropdown
          *ngIf="optionPeriodDropdown"
          (triggerEvent)="handlePeriodDropdownEvent($event)"
          [pickValue]="filterPickedValue"
          [options]="optionPeriodDropdown"></app-global-dropdown>
        <button
          *ngIf="period !== 'all'"
          (click)="handleCustomPeriod()"
          type="button"
          class="flex items-center gap-2 text-sm w-fit text-blue font-semibold bg-white focus:outline-none hover:bg-kimbo-blue hover:bg-opacity-10 focus:ring-4 focus:ring-blue-800 rounded-lg px-5 py-2.5 me-2 mb-2">
          <mat-icon color="primary">calendar_today</mat-icon>
          <span>{{ startDateToDisplay }}</span>
          -
          <span>{{ endDateToDisplay }}</span>
        </button>
      </div>
      <span class="text-lg font-semibold text-kimbo-blue">{{
        'kimbo-home.transaction-total-period'
          | translate
            : {
                amount: _toMoney(totalAmount) | number : '1.2-2',
                currency: currency.code
              }
      }}</span>
    </div>

    <div class="-my-2 overflow-x-auto">
      <div class="inline-block max-w-[1400px] min-w-full py-2 align-middle">
        <div
          class="overflow-x-scroll border border-gray-200 dark:border-gray-700 md:rounded-lg">
          <table
            class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 {{
              isTransitioning ? 'opacity-50 pointer-events-none' : ''
            }}">
            <thead class="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th
                  scope="col"
                  class="py-3.5 px-4 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <div class="flex items-center gap-x-3">
                    <span>
                      {{ 'kimbo-home.agent-label' | translate }}
                    </span>
                  </div>
                </th>

                <th
                  scope="col"
                  class="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  {{ 'admin-fields.source-group-label' | translate }}
                </th>

                <th
                  scope="col"
                  class="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  {{ 'admin-fields.amount-label' | translate }}
                </th>

                <th
                  scope="col"
                  class="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  {{ 'admin-fields.kind-label' | translate }}
                </th>

                <th
                  scope="col"
                  class="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  {{ 'kimbo-home.beneficiary-label' | translate }}
                </th>

                <th
                  scope="col"
                  class="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  {{ 'kimbo-home.customer' | translate }}
                </th>

                <th
                  scope="col"
                  class="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  {{ 'admin-fields.created-at-label' | translate }}
                </th>
              </tr>
            </thead>

            <tbody
              *ngIf="!isTransitioning"
              class="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
              <tr *ngFor="let transaction of transactions">
                <td
                  class="px-4 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                  <div
                    *ngIf="transaction.user"
                    class="flex flex-col items-start justify-center">
                    <span
                      *ngIf="
                        transaction.user &&
                        transaction.user.properties &&
                        transaction.user.properties.name
                      ">
                      {{
                        transaction.user &&
                          transaction.user.properties &&
                          (transaction.user.properties.name ?? '')
                      }}
                    </span>
                    <span>
                      {{
                        transaction.user.properties?.email ??
                          transaction.user.properties?.tel
                      }}
                    </span>
                  </div>
                  <span *ngIf="!transaction.user" class="">
                    {{ 'admin-fields.no-user-transaction' | translate }}
                  </span>
                </td>
                <td
                  class="px-12 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                  <a
                    *ngIf="transaction.targetable"
                    class="font-medium flex justify-start gap-2 items-center">
                    <div
                      *ngIf="transaction.type !== transactionType.RECIVECREDITS"
                      class="flex flex-row justify-start items-center gap-2">
                      <app-avatar
                        *ngIf="transaction.targetable.image_profil"
                        class="w-8 h-8 flex-shrink"
                        classNames="w-8 h-8"
                        [withFrame]="false"
                        [src]="
                          transaction.targetable.image_profil | imageToUrl
                        "></app-avatar>
                      <span
                        class="text-sm overflow-hidden overflow-ellipsis whitespace-nowrap">
                        {{ transaction.targetable?.name }}
                      </span>
                    </div>
                    <div
                      *ngIf="transaction.type === transactionType.RECIVECREDITS"
                      class="flex flex-row justify-start items-center gap-2">
                      <app-avatar
                        *ngIf="transaction.transactionable.image_profil"
                        class="w-8 h-8 flex-shrink"
                        classNames="w-8 h-8"
                        [withFrame]="false"
                        [src]="
                          transaction.transactionable.image_profil | imageToUrl
                        "></app-avatar>
                      <span
                        class="text-sm overflow-hidden overflow-ellipsis whitespace-nowrap">
                        {{ transaction.transactionable.name }}
                      </span>
                    </div>
                  </a>
                </td>
                <td
                  class="px-4 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                  {{ _toMoney(transaction.hc_amount) * -1 }}
                  {{ currency.code }}
                </td>
                <td
                  class="px-4 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                  <span>
                    {{
                      'admin-financial-transactions.' + transaction.type
                        | translate
                    }}
                  </span>
                </td>

                <td
                  class="px-4 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                  <span
                    *ngIf="transaction.type === transactionType.RECIVECREDITS">
                    <div
                      *ngIf="transaction.targetable"
                      class="font-medium flex justify-start gap-2 items-center">
                      <app-avatar
                        *ngIf="transaction.targetable?.image_profil"
                        class="w-8 h-8 flex-shrink"
                        classNames="w-8 h-8 mr-2"
                        [withFrame]="false"
                        [src]="
                          transaction.targetable.image_profil | imageToUrl
                        "></app-avatar>
                      <div class="flex flex-col items-start justify-center">
                        <span
                          class="text-sm overflow-hidden overflow-ellipsis whitespace-nowrap">
                          {{ transaction.targetable?.name }}
                        </span>
                        <span
                          *ngIf="
                            transaction.targetable?.owner &&
                            transaction.targetable.owner.adresse &&
                            transaction.targetable.owner.adresse?.name
                          "
                          class="text-sm overflow-hidden overflow-ellipsis whitespace-nowrap">
                          ({{ transaction.targetable.owner.adresse.name }})
                        </span>
                      </div>
                    </div>
                  </span>

                  <span
                    class="flex flex-row items-center"
                    *ngIf="
                      transaction.type ===
                        transactionType.HEALTHCAREPACKAGEDEBIT ||
                      transaction.type ===
                        transactionType.HEALTHCAREPACKAGEBUY ||
                      transaction.type ===
                        transactionType.HEALTHCAREPACKAGEREST ||
                      transaction.type === transactionType.BUYEDPACKAGE_CANCLED
                    ">
                    <img
                      *ngIf="
                        transaction.type !==
                        transactionType.HEALTHCAREPACKAGEREST
                      "
                      [src]="
                        transaction.transactionable?.patient?.image_profil
                          ? (transaction.transactionable.patient.image_profil
                            | imageToUrl)
                          : ''
                      "
                      class="w-8 h-8 rounded-full object-cover mr-2"
                      alt="imge user" />
                    <img
                      *ngIf="
                        transaction.type ===
                        transactionType.HEALTHCAREPACKAGEREST
                      "
                      src="assets/images/refund.png"
                      alt="refund"
                      class="w-8 mr-2" />

                    <div class="flex flex-col items-start justify-center">
                      <span>
                        {{
                          transaction.transactionable?.patient &&
                          transaction.transactionable.patient.adresse
                            ? transaction.transactionable.patient.adresse?.name
                            : ''
                        }}
                      </span>
                      <span>
                        {{
                          transaction.transactionable?.patient &&
                          transaction.transactionable.patient.email
                            ? transaction.transactionable.patient.email
                            : transaction.transactionable?.patient?.tel
                        }}
                      </span>
                    </div>
                  </span>

                  <span
                    class="font-medium flex justify-start gap-2 items-center"
                    *ngIf="transaction.type === transactionType.TOPUP">
                    <img
                      appImg
                      *ngIf="
                        transaction.targetable_type ===
                        payableType.HEALTHCAREPROVIDER
                      "
                      class="w-8 h-8"
                      alt="group picture"
                      src="assets/images/hospital.png" />
                    <app-avatar
                      *ngIf="
                        transaction.targetable_type !==
                          payableType.HEALTHCAREPROVIDER &&
                        transaction.targetable?.image_profil
                      "
                      class="w-8 h-8 flex-shrink"
                      classNames="w-8 h-8"
                      [withFrame]="false"
                      [src]="
                        transaction.targetable?.image_profil | imageToUrl
                      "></app-avatar>
                    <span
                      class="text-sm overflow-hidden overflow-ellipsis whitespace-nowrap">
                      {{ transaction.targetable?.name }}
                    </span>
                  </span>
                </td>
                <td class="px-4 py-4 text-sm whitespace-nowrap">
                  <div class="flex flex-col items-start justify-center">
                    <span>
                      {{ transaction.data.client?.name ?? '__' }}
                    </span>
                    <span>
                      {{ transaction.data.client?.email ?? '__' }}
                    </span>
                  </div>
                </td>
                <td class="px-4 py-4 text-sm whitespace-nowrap">
                  <div class="flex items-center gap-x-2">
                    {{ toLocaleDateTime(transaction.created_at) }}
                  </div>
                </td>
              </tr>

              <tr *ngIf="transactions.length === 0">
                <td
                  colspan="7"
                  class="p-2 break-words flex-shrink-0 w-full text-center text-gray">
                  {{ 'forms.no-data' | translate }}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            *ngIf="isLoading"
            role="status"
            class="p-6 flex justify-center items-center w-full">
            <svg
              aria-hidden="true"
              class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-kimbo-blue"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill" />
            </svg>
          </div>
        </div>
        <app-pagination
          *ngIf="!isLoading && this.pagination.totalPages > 1"
          (triggerEvent)="setPage($event)"
          shape="_COMPOSED"
          [params]="{ className: 'my-6', pagination }"></app-pagination>
      </div>
    </div>
  </div>
</div>
